export const DASHBOARD_LIBRARY_ROUTES = {
  Template: '/dashboard/template',
};
